module.exports = __webpack_public_path__ + "static/media/ikedc.ec5e4710.svg";